import { Component, Input, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { HistInfo } from '../../../core/gb-api';
import { LinkComponent } from '../../components/link/link.component';
import { HistoryDirective } from '../../directives/history.directive';
import { NgTemplateOutlet, SlicePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  imports: [LinkComponent, HistoryDirective, NgTemplateOutlet, SlicePipe, TranslatePipe]
})
export class ReadMoreComponent implements OnInit {
  @Input()
  text: string;
  @Input()
  texts: string[];
  @Input()
  maxWidth = 100;
  @Input()
  limit = 100;
  @Input()
  textIsLink = false;
  @Input()
  target: string;
  @Input()
  queryParams: { [k: string]: any };
  @Input()
  tooltipDetail: string;
  @Input()
  histInfo: HistInfo;

  public isCollapsed = false;
  public isCollapsable = false;
  public concatedText: string;
  // minimum Length the text has to be longer than the limit for the 'show more' to show up
  readonly MINIMUM_NUMBER_OF_CUTOFF_CHARACTERS = 10;

  constructor() {
    keysToTranslate<string>(['MehrAnzeigen', 'WenigerAnzeigen']);
  }

  ngOnInit(): void {
    if (this.text && this.texts) {
      throw new Error("Do not set the attributes 'text' and 'texts' at the same time.");
    }

    if (this.text) {
      this.concatedText = this.text;
    } else if (this.texts) {
      this.concatedText = this.texts.join(' ');
    }

    if (this.concatedText) {
      const currentTextLenght = this.concatedText.length;

      // collapsable only if the contents make container exceed the max height
      if (currentTextLenght > this.limit + this.MINIMUM_NUMBER_OF_CUTOFF_CHARACTERS) {
        this.isCollapsed = true;
        this.isCollapsable = true;
      }
    }
  }
}
